import { useQuery } from "@tanstack/react-query";

import { getBeefHerdDetails, getBeefHerdDetailsAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE, FOOTPRINTING_BEEF_HERD_DETAILS } from "consts";

import { FootprintingBeefHerdDetails } from "models";

export const useGetFootprintingBeefHerdDetails = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<FootprintingBeefHerdDetails>({
    queryKey: [FOOTPRINTING_BEEF_HERD_DETAILS, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getBeefHerdDetailsAdmin(primaryDataId) : getBeefHerdDetails(primaryDataId)),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
